import { useEffect } from "react";
import { getSurgery } from "../../../apiHandler/actions/profile";
import { displayDateFormatter, DataGridCustomPagination } from "../../helpers";
import { Skeleton } from "@material-ui/lab";

import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "nameOfSurgery", headerName: "Name Of Surgery", flex: 1 },
  { field: "nameOfHospital", headerName: "Hospital/Clinic Name", flex: 1 },
  { field: "phone", headerName: "Contact Number", flex: 1 },
  { field: "date", headerName: "Date", flex: 1 },
];

const Component = (props) => {
  const { surgery, setSurgery } = props;

  useEffect(() => {
    if (surgery === null) fetchAllergies();
    // eslint-disable-next-line
  }, []);

  const fetchAllergies = async () => {
    const response = await getSurgery(props.uuid);
    setSurgery(
      response.procedure &&
        response.procedure.map((s) => {
          return {
            id: s.id,
            nameOfSurgery: s.code?.coding?.[0]["code"],
            nameOfHospital: s.location[0]?.text,
            phone: s.performer[0]?.actor?.Practitioner?.telecom[0]?.value,
            date: displayDateFormatter(s.performedDateTime),
          };
        })
    );
  };

  return (
    <div>
      {surgery === null ? (
        <div className="mj-skeleton-container">
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        </div>
      ) : Array.isArray(surgery) && surgery.length !== 0 ? (
        <DataGrid
          rows={surgery}
          columns={columns}
          autoHeight="true"
          disableRowSelectionOnClick
          pagination
          pageSize={5}
          slots={{
            pagination: DataGridCustomPagination,
          }}
        />
      ) : (
        <p className="mj-no-records">No records to display</p>
      )}
    </div>
  );
};

export default Component;
